export enum NOTIFICATION_CATEGORIES {
  FAULT_REPORTING = "fault_reporting",
  INT_SERVICE_CONTRACT = "int_service_contract",
  EXT_SERVICE_CONTRACT = "ext_service_contract",
  PREDICTIVE_SERVICE = "predictive_service",
  ENERGY_LOSS = "energy_loss",
  REPAIR_REQUEST = "repair_request",
}

export type NotificationCategory = `${NOTIFICATION_CATEGORIES}`;
